export default {
  // 格式化文件单位
  file_format_size: size => {
    let i
    const unit = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
    for (i = 0; i < unit.length && size >= 1024; i++) {
      size /= 1024
    }
    return (Math.round(size * 100) / 100 || 0) + unit[i]
  },
  // 文件下载
  file_download: (url, fileName) => {
    const a = document.createElement('a')
    document.body.append(a)
    a.href = url
    a.download = fileName
    // 超链接 target="_blank" 要增加 rel="noopener noreferrer" 来堵住钓鱼安全漏洞。如果你在链接上使用 target="_blank"属性，并且不加上rel="noopener"属性，那么你就让用户暴露在一个非常简单的钓鱼攻击之下。(摘要)
    a.rel = 'noopener noreferrer'
    a.click()
    document.body.removeChild(a)
  },
  // 文件下载
  file_download_by_iframe: url => {
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = url
    document.body.appendChild(iframe)
  },
  file_download_by_a: url => {
    const a = document.createElement('a')
    a.href = url
    a.download = true
    a.click()
  },
  // 生成txt文件
  create_txt: (filename, text) => {
    const a = document.createElement('a')
    a.setAttribute(
      'href',
      'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
    )
    a.setAttribute('download', filename)
    a.style.display = 'none'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  },
  // 生成iframe
  handler_create: targetUrl => {
    const div = document.createElement('div')
    div.id = 'iframeBox'
    div.style.height = 'calc(100% - 105px)'
    div.innerHTML = `<iframe id="idFrame" name="idFrame" src="${targetUrl}" height = "100%" width = "100%" frameborder="0" scrolling="auto"></iframe>`
    // div.innerHTML = `<iframe id="idFrame" name="idFrame" src="${targetUrl}" height = "0" width = "0" frameborder="0" scrolling="auto" style = "display:none;visibility:hidden" ></iframe>`
    document.body.appendChild(div)
    getDataOnIframe()
  },
  // 获得iframe的数据
  get_data_on_iframe: () => {
    const iframe = document.querySelector('#idFrame')
    // console.log(iframe)
    // const list = iframe.contentWindow.document.querySelectorAll('a[data-fancybox="gallery"]')
    // const list = window.frames["idFrame"].document.querySelectorAll('a[data-fancybox="gallery"]')
    // const list = window.frameElement.contentDocument.querySelectorAll('a')
    // const list = document.querySelector('.xl-chrome-ext-bar')
    // const list = iframe.contentWindow.document.body.innerHTML
    // console.log(list)
    // console.log(iframe,iframe.contentWindow,iframe.contentWindow.document,iframe.contentWindow.document.body,iframe.contentWindow.document.body.innerHTML)
    if (iframe.attachEvent) {
      iframe.attachEvent('onload', function() {
        console.log(iframe.contentWindow.document.querySelectorAll('a'))
      })
    } else {
      iframe.onload = function() {
        console.log(iframe.contentWindow.document.querySelectorAll('a'))
      }
    }
  },
}
